import Typography from "typography"

export const typography = new Typography({
  title: "Typography",
  baseFontSize: "16px",
  baseLineHeight: 1.4,
  headerFontFamily: [`Poppins`, "Open Sans", "Arial"],
  bodyFontFamily: [`Poppins`, "Open Sans", "Arial"],
  headerWeight: 400,
})

export default typography
